/**
 * Campus Filter Hook
 * Provides the currently selected campus ID for filtering data
 */

import { useUIStore } from "@/store/uiStore";

/**
 * Hook to get the current campus filter
 * Returns null when "All Campuses" is selected
 *
 * Usage in other hooks:
 * ```typescript
 * export const useStudents = (params?: ListStudentsParams) => {
 *   const campusId = useCampusFilter();
 *
 *   return useQuery({
 *     queryKey: studentsKeys.list({ ...params, campus_id: campusId }),
 *     queryFn: async () => {
 *       const response = await studentsApi.list({
 *         ...params,
 *         campus_id: campusId || undefined
 *       });
 *       return response.data;
 *     },
 *   });
 * };
 * ```
 */
export const useCampusFilter = (): string | null => {
  const { selectedCampusId } = useUIStore();
  return selectedCampusId;
};
